import { styled } from '@mui/material';

const StyledWrapper = styled('div')({
  marginTop: '24px',
});

export default StyledWrapper;
